import React from 'react'

export type Props = {
  label: string
  icon?: string
}

const ListItemIcon: React.FC<Props> = ({ label, icon = undefined }) => (
  <div className="flex items-center space-x-4 text-sm md:text-base">
    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-gray-200">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {icon && <img src={icon} width={24} height={24} alt={label} />}
    </div>
    <p>{label}</p>
  </div>
)

export default ListItemIcon
